import React, { Component } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import translate from '../../../components/TranslateHOC';
import { Icon as IconV2 } from '../icon/Icon';

class ListItemSubtitlesV2 extends Component {
  render() {
    const { details, strings, isMobile } = this.props;
    if (isMobile) {
      return (
        (details.b888 === 'Y' ||
          details.b889 === 'Y' ||
          details.b_audio_described === 'Y' ||
          details.b_visually_signed === 'Y') && (
          <ListItemSubtitlesContainer>
            {details.b888 === 'Y' && (
              <Subtitles>{strings.englishSubtitles}</Subtitles>
            )}
            {details.b889 === 'Y' && (
              <Subtitles>{strings.welshSubtitles}</Subtitles>
            )}
            {details.b_audio_described === 'Y' && (
              <AudioDescribed>{strings.audioDescribed}</AudioDescribed>
            )}
            {details.b_visually_signed === 'Y' && (
              <Signed>{strings.signed}</Signed>
            )}
          </ListItemSubtitlesContainer>
        )
      );
    } else {
      return (
        (details.b888 === 'Y' ||
          details.b889 === 'Y' ||
          details.b_audio_described === 'Y' ||
          details.b_visually_signed === 'Y') && (
          <>
            {details.b888 === 'Y' && details.b889 === 'Y' && (
              <TagContainer>
                <IconV2 type="material" materialLabel="keyboard" size="small" />
                <Subtitles>{strings.welshEnglishSubtitles}</Subtitles>
              </TagContainer>
            )}
            {details.b888 === 'Y' && details.b889 === 'N' && (
              <TagContainer>
                <IconV2 type="material" materialLabel="keyboard" size="small" />
                <Subtitles>{strings.englishSubtitles}</Subtitles>
              </TagContainer>
            )}
            {details.b889 === 'Y' && details.b888 === 'N' && (
              <TagContainer>
                <IconV2 type="material" materialLabel="keyboard" size="small" />
                <Subtitles>{strings.welshSubtitles}</Subtitles>
              </TagContainer>
            )}
            {details.b_audio_described === 'Y' && (
              <TagContainer className="large">
                <IconV2 type="custom" customLabel="chat_bubble" size="small" />
                <AudioDescribed>{strings.audioDescribed}</AudioDescribed>
              </TagContainer>
            )}
            {details.b_visually_signed === 'Y' && (
              <TagContainer>
                <IconV2 type="custom" customLabel="chat_bubble" size="small" />
                <Signed>{strings.signed}</Signed>
              </TagContainer>
            )}
          </>
        )
      );
    }
  }

  static propTypes = {
    details: PropTypes.object.isRequired,
  };
}

const TagContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 20px;
  &.large span:empty {
    width: 14px !important;
    height: 14px !important;
  }
`;

const Tag = styled.span`
  color: ${(props) =>
    props.theme.name === 'light'
      ? `${props.theme.color.black90}`
      : `${props.theme.color.white70}`};
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.1px;
`;
const Subtitles = styled(Tag)``;
const AudioDescribed = styled(Tag)``;
const Signed = styled(Tag)``;

const ListItemSubtitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  ${Tag} {
    color: ${(props) =>
      props.theme.name === 'light'
        ? `${props.theme.color.black50}`
        : `${props.theme.color.whiteFull}`};
    font-weight: normal;
  }
`;

export default translate(connect(null)(ListItemSubtitlesV2));
